import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showErrorNotification } from "@utils/showNotification";


export const useSendPasswordResetLink = () => {
  return useMutation({
    mutationFn: ({ email }: { email: string }) => {
      return api.post(
        "user/reset-password/",
        {
          email,
        },
        { params: { client_url: window.origin } }
      );
    },

    onError: (res: any) => {
      console.error("[From Send Password Reset Link]", res);

      switch (res?.response?.status) {
        case 404:
          showErrorNotification({
            title: "email-not-found-title",
            message: "email-not-found-message",
          });
          break;
        case 400:
        case 422:
          showErrorNotification({
            title: "invalid-input-title",
            message: "invalid-input-message",
          });
          break;
        default:
          showErrorNotification({ title: "oops", message: "unexpected-error" });
          break;
      }
    },
  });
};
